import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import InputMultiFiles from 'core/components/InputMultiFiles.vue'
import ImagemComFallback from 'core/components/ImagemComFallback.vue'
import Overlay from 'core/components/Overlay.vue'

const requireComponent = require.context('/', true, /\.vue$/)

requireComponent.keys().forEach(fileName => {
  if (fileName.indexOf('AppLayout') < 0) {
    const componentConfig = requireComponent(fileName)

    const componentName = upperFirst(
      camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
    )

    Vue.component(componentName, componentConfig.default || componentConfig)
  }
})

Vue.component('InputMultiFiles', InputMultiFiles)
Vue.component('ImagemComFallback', ImagemComFallback)
Vue.component('Overlay', Overlay)
